import { render, staticRenderFns } from "./TravTabs.vue?vue&type=template&id=134fcf86&scoped=true"
import script from "./TravTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./TravTabs.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TravTabs.vue?vue&type=style&index=0&id=134fcf86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fcf86",
  null
  
)

export default component.exports